/**
 * Menu controller.
 *
 * This class controls the site menu and search functions.
 */
// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class Menu
 */
class Menu {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {
    }

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {


        // The mobile menu toggler icon.
        this.mobileOverlayToggler = document.getElementById( 'js-mobile-overlay-toggle' );

        // Toggler expanded strings
        this.ariaLabelClose = themeData.themeStrings.menu.open.aria;
        this.ariaLabelOpen = themeData.themeStrings.menu.close.aria;

        // The mobile full screen overlay that contains the mobile menu.
        this.mobileOverlay = document.getElementById( 'js-mobile-overlay' );

        // The mobile nav element.
        this.mobileMenu = document.getElementById( 'js-mobile-menu' );
        this.mobileSearchButton = document.getElementById( 'js-search-button' );

        // Get first and last focusable elements of the mobile menu.
        if ( this.mobileMenu ) {

            const focusableElements = this.mobileMenu.querySelectorAll( 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]' );
            if ( focusableElements.length ) {
                const focusableElementsArr = Array.prototype.slice.call( focusableElements );

                focusableElementsArr.push( this.mobileSearchButton );

                this.firstMobileMenuLink = focusableElementsArr[0];
                this.lastMobileMenuLink = focusableElementsArr[focusableElementsArr.length - 1];

                // The visual order of things differs a bit from the tabbing, hence getting the last
                // language item here to be focused when shift+tab from search
                this.secondLastMobileMenuLink = focusableElementsArr[focusableElementsArr.length - 2];

            }
        }

        // Get the whole main nav to control when focusing out
        this.desktopMenu = document.getElementById ( 'js-nav--desktop' );

         // Get first and last focusable elements of the desktop menu.
         if ( this.desktopMenu ) {

            const focusableElements = this.desktopMenu.querySelectorAll( 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]' );
            if ( focusableElements.length ) {
                const focusableElementsArr = Array.prototype.slice.call( focusableElements );

                this.firstdesktopMenuLink = focusableElementsArr[0];
                this.lastdesktopMenuLink = focusableElementsArr[focusableElementsArr.length - 1];

            }
        }

        // Each top level menu item that has children.
        this.menuParents = Theme.Common.$( '.js-main-menu-nav .menu-item-has-children' );

        // Submenus & menu items with submenus
        this.submenus          = $( '.submenu' );
        this.submenusLvl2      = $( '.submenu-wrap-2' );
        this.submenusLvl3      = $( '.submenu-wrap-3' );

        this.menuItemsChildren = $( '.nav--desktop' ).find( '.menu-item-has-children' );
        this.menuItemsLvl1     = this.menuItemsChildren.find( '.menu-depth-1__item__link' );
        this.submenuTogglers   = this.menuItemsChildren.find( 'button' );

        // The wide background wrap for submenus
        this.wideBackgroundWrap = $( '.content-wrap-wide-2' );

        // Get mobile togglers
        this.mobileSubmenuTogglers = $( '.main-menu--mobile' ).find( '.submenu-toggler' );

        // Get mobile sign language links
        this.mobileSignLanguageLinks = $( '.main-menu--mobile' ).find( '.signlanguage' ).find( '.menu-link' );

        // The background wrapper for when the desktop menu is open
        this.backgroundWrapper = $( '#js-nav-background-overlay' );
    }

    /**
     * All events of the menus
     * @return {void}
     */
    events() {
        document.addEventListener( 'keydown', evt => this.keyDownHandler( evt ) );

        // Go through each lvl 1 menu item and bind them to a click function,
        // to open its submenu if it has one
        this.menuItemsLvl1.each( ( index, menuItem ) => {

            $( menuItem ).on( 'click', ( e ) => {
                Theme.Common.stop( e );

                // Get the depth to know which submenu to open
                const clickedMenuListItem = $( e.currentTarget ).parent( 'li' );
                const currentDepth = clickedMenuListItem.data( 'depth' );

                // Control the expanded status of this opened dropdown
                const expandedStatus = $( menuItem ).attr( 'aria-expanded' );

                if ( expandedStatus == 'false' ) {
                    $( menuItem ).attr( 'aria-expanded', 'true' );
                } else {
                    $( menuItem ).attr( 'aria-expanded', 'false' );
                }

                // Open the wanted submenu, let the function know the
                // <li> item of the clicked link and its depth
                this.openSubmenu( clickedMenuListItem, currentDepth );


                // Toggle the background wrapper visible if there is an open nav element.
                // We fire this after the submenu function to be sure that the class 'js-current-lvl1-marker'
                // has had its time to toggle
                if ( $( menuItem ).hasClass( 'js-current-lvl1-marker' ) ) {
                    this.backgroundWrapper.removeClass( 'js-hidden' );
                } else {
                    this.backgroundWrapper.addClass( 'js-hidden' );
                }

            });
        });

        // Go through each submenu toggler button and bind them to a click function
        // to open the wanted submenu
        this.submenuTogglers.each( ( index, menuItem ) => {

            $( menuItem ).on( 'click', ( e ) => {

                // Get the current clicked menu toggler as a jquery object
                const clickedButton = $( e.currentTarget );

                // Toggle the icons to change for current button
                clickedButton.find( '.submenu-toggler-closed' ).toggleClass( 'submenu-toggler__js-hidden' );
                clickedButton.find( '.submenu-toggler-open' ).toggleClass( 'submenu-toggler__js-hidden' );

                // From the opened submenu instance, mark all the submenu icons closed
                // but this one, and in other submenu instances, keep the opened icons open
                // For this we need to find the closest parent to bind them

                // Get the parent wrapper, and the parent wrappers icons we want to control
                const submenuLvl2Wrap      = clickedButton.parents( '.menu-depth-2' );
                const submenuLvl2WrapIcons = submenuLvl2Wrap.find( '.submenu-toggler' ).not( clickedButton );

                // Set all the other submenu icons to "closed"
                submenuLvl2WrapIcons.find( '.submenu-toggler-closed' ).removeClass( 'submenu-toggler__js-hidden' );
                submenuLvl2WrapIcons.find( '.submenu-toggler-open' ).addClass( 'submenu-toggler__js-hidden' );

                // Screen reader texts to indicate if submenu is open or closed.
                const openLabel  = clickedButton.find( '.open-submenu' );
                const closeLabel = clickedButton.find( '.close-submenu' );

                // Control the aria expanded state
                const ariaExpanded = clickedButton.attr( 'aria-expanded' );
                if ( ariaExpanded == 'true' ) {
                    clickedButton.attr( 'aria-expanded', 'false' );
                    closeLabel.attr( 'aria-hidden', 'true' );
                    openLabel.attr( 'aria-hidden', 'false' );
                } else {
                    clickedButton.attr( 'aria-expanded', 'true' );
                    closeLabel.attr( 'aria-hidden', 'false' );
                    openLabel.attr( 'aria-hidden', 'true' );
                }

                // Mark all the other submenu togglers in this opened nav to be not expanded
                submenuLvl2Wrap.find( 'button' ).not( clickedButton ).attr( 'aria-expanded', 'false' );

                // Get the depth to know which submenu to open
                const clickedMenuListItem = clickedButton.parent( 'li' );
                const currentDepth = clickedMenuListItem.data( 'depth' );

                // Open the wanted submenu, let the function know the
                // <li> item of the clicked link and its depth
                this.openSubmenu( clickedMenuListItem, currentDepth );

            });
        });

        // Hide desktop nav by clicking the wrapper
        this.backgroundWrapper.on( 'click', ( e ) => {
            this.hideSubmenus();
        });

        // Go through each submenu toggler to toggle the wanted menu open on mobile
        this.mobileSubmenuTogglers.each( ( index, toggler ) => {

            $( toggler ).on( 'click', ( e ) => {

                const clickedButton = $( e.currentTarget );
                this.openMobileSubmenu( clickedButton );

            });
        });
    }

    /**
     * Add sign language icon to mobile signlanguage classed nav links
     */
    addSignlanguageIcon() {
        this.mobileSignLanguageLinks.each( ( e, signLanguageLink ) => {
            $( signLanguageLink ).prepend( '<i class="fal fa-sign-language" aria-hidden="true"></i>' );
        });
     }

    /**
     * Toggles the next submenu related to the clicked button in mobile navigation
     *
     * @param {object} clickedButton
     */
    openMobileSubmenu( clickedButton ) {

        // Traverse to find the next submenu to the clicked toggler button: get the parent wrapper and its sibling submenu
        const submenuToOpen = clickedButton.parents( '.menu-link-wrapper' ).siblings( '.mobile-submenu-wrap' );

        // SlideToggle the clicked submenu
        submenuToOpen.slideToggle( 'fast' );

        // Toggle the icon to change. .fas = font awesome icon.
        clickedButton.find( '.fas' ).toggleClass( 'submenu-toggler__js-hidden' );

        // Screen reader texts to indicate if submenu is open or closed.
        const openLabel  = clickedButton.find( '.open-submenu' );
        const closeLabel = clickedButton.find( '.close-submenu' );

        // Update aria expanded
        const ariaExpanded = clickedButton.attr( 'aria-expanded' );
        if ( ariaExpanded == 'false' ) {
            clickedButton.attr( 'aria-expanded', 'true' );
            closeLabel.attr( 'aria-hidden', 'false' );
            openLabel.attr( 'aria-hidden', 'true' );
        } else {
            clickedButton.attr( 'aria-expanded', 'false' );
            closeLabel.attr( 'aria-hidden', 'true' );
            openLabel.attr( 'aria-hidden', 'false' );
        }

    }

    /**
     * Handle keydown events.
     *
     * @param {object} evt The key push event.
     * @return {void}
     */
    keyDownHandler( evt ) {

        evt = evt || window.event;

        const KEY_TAB = 9;
        const KEY_ESC = 27;

        switch ( evt.keyCode ) {
            case KEY_TAB:

                // Focus on mobileOverlayToggler and return early if no other focusable elements found.
                if ( ! this.firstMobileMenuLink && this.mobileOverlayToggler ) {
                    evt.preventDefault();
                    this.mobileOverlayToggler.focus();
                    break;
                }

                this.handleTabKeyEvent( evt );

                break;

            case KEY_ESC:

                // If desktop navigation is open, close it
                if ( this.menuItemsLvl1.hasClass( 'js-current-lvl1-marker' ) ) {
                    this.hideSubmenus();
                }


                // If mobile overlay is open, close it
                if ( $( this.mobileOverlay ).hasClass( 'js-active' ) ) {
                    this.toggleMobileOverlay();
                    break;
                }

            default:
                break;
        } // end switch
    }


    /**
     * Handle tab key pushes inside modal.
     *
     * @param {object} evt The key push event.
     * @return {void}
     */
    handleTabKeyEvent( evt ) {

        // If shift + tab pushed.
        if ( evt.shiftKey ) {

            // If first desktop link, then remove all active classes and hide submenus
            if ( document.activeElement === this.firstdesktopMenuLink ) {
                this.hideSubmenus();
            }

        } else {

            // If last desktop link, then remove all active classes and hide submenus
            if ( document.activeElement === this.lastdesktopMenuLink ) {
                this.hideSubmenus();
            }
        }
    }

    /**
     * Toggles the mobile menu overlay open and closed
     * @return {void}
     */
    toggleMobileOverlay() {

        // Return early if missing required elements.
        if ( ! this.mobileOverlayToggler ||  ! this.mobileOverlay ) {
            return;
        }

        // Toggle the overlay's and the mobileOverlayToggler's active states.
        this.mobileOverlay.classList.toggle( 'js-active' );
        this.mobileOverlayToggler.classList.toggle( 'js-active' );

        // Get the toggler's aria-expanded current state and set a new opposite state to it.
        // Also set the opened container's aria-hidden state to the new value's opposite.
        const ariaExpandedState = this.mobileOverlayToggler.getAttribute( 'aria-expanded' ) === 'false' ? true : false;
        this.mobileOverlayToggler.setAttribute( 'aria-expanded', ariaExpandedState );
        this.mobileOverlay.setAttribute( 'aria-hidden', ! ariaExpandedState );

        // Return early if mobileOverlayToggler closed. Also set aria label according to the buttons status
        if ( ! this.mobileOverlay.classList.contains( 'js-active' ) ) {
            this.mobileOverlayToggler.focus();

            $( this.mobileOverlayToggler ).attr( 'aria-label', this.ariaLabelClose )
;            return;
        } else {
            $( this.mobileOverlayToggler ).attr( 'aria-label', this.ariaLabelOpen );
        }

        // Set a small delay to the focusing to back of mobile menu's toggler
        // because of the CSS fade in
        if ( this.mobileOverlay ) {
            setTimeout( () => {
                this.mobileOverlayToggler.focus();
            }, 500 );
        }

    }

    /**
     * Hide all the submenus
     */
    hideSubmenus() {

        // Hide the background wrapper
        this.backgroundWrapper.addClass( 'js-hidden' );

        // Hide menus and markers
        this.menuItemsLvl1.removeClass( 'js-current-lvl1-marker' );
        this.submenus.addClass( 'submenu--hidden' );

        // Add hidden class to submenu lvl 2 & 3 wrappers
        this.submenusLvl2.addClass( 'submenu-wrap-2--hidden' );
        this.submenusLvl3.addClass( 'submenu-wrap-3--hidden' );
        this.submenusLvl3.addClass( 'submenu-wrap-3--hidden' );

        // Submenu markers to closed
        $( '.submenu-toggler-closed' ).removeClass( 'submenu-toggler__js-hidden' );
        $( '.submenu-toggler-open' ).addClass( 'submenu-toggler__js-hidden' );

        // To recalculate the height for the background wrap
        this.wideBackgroundWrap.css( 'height', 'auto' );
    }

    /**
     * Control which submenu to open, and calculate correct height if menu level is 3
     *
     * @param {dom object} clickedMenuItem
     * @param {int} currentDepth
     */
     openSubmenu( clickedMenuItem, currentDepth ) {

        // Get the current clicked menu item as a jquery object
        const activeMenuItem = $( clickedMenuItem );

        // Calculate the submenu depth to open
        const depthToOpen = currentDepth + 1;

        // Find the submenu and toggle it visible
        const submenuToOpen = activeMenuItem.find( '.menu-depth-' + depthToOpen );

        // Check if the current depth to open is lvl3, and go here to build the structure
        // for the togglable nav
        if ( depthToOpen == 3 ) {

            // Get the wide main wrapper and set its height to auto,
            // and change it if needed later on
            const submenuMainBg = activeMenuItem.parents( '.content-wrap-wide-2' );
            submenuMainBg.css( 'height', 'auto' );

            // Get the background wrap for the current submenu to be opened
            const submenuToOpenBgWrap = submenuToOpen.parents( '.submenu-wrap-3' );

            // Hide all submenus lvl 3 but this one - hide the bg wrapper and the content itself
            submenuMainBg.find( '.submenu-wrap-3' ).not( submenuToOpenBgWrap ).addClass( 'submenu-wrap-3--hidden' );
            submenuMainBg.find( '.menu-depth-3' ).not( submenuToOpen ).addClass( 'submenu--hidden' );

            // Toggle the current submenu to visible or hidden
            // according to its current status
            submenuToOpenBgWrap.toggleClass( 'submenu-wrap-3--hidden' );

            // Get level 2 menu wrapper, it has the same height as the menu inside it,
            // but controls the background color. Get its height to compare it to lvl 3
            // submenu height
            const submenuMainBgHeight = submenuMainBg.height();

            // Toggle submenu level 3 content wrap open or closed, according to its current status
            $( submenuToOpen ).toggleClass( 'submenu--hidden' );

            // Get level 3 submenu height by its parent height to include padding
            const submenuToOpenHeight = submenuToOpen.parents( '.content-wrap-wide-3' ).height();

            // Compare the submenus height to the wide parent wrappers height, and adjust
            // if needed
            if ( submenuToOpenHeight > submenuMainBgHeight ) {
                submenuMainBg.height( submenuToOpenHeight );
            };

        // ELSE: if the sub menu we are opening is not level 3 submenu, but the wide
        // wrap, level 2
        } else {

            // Toggle the current menu-item level 1 <a> to be active, to give it a downwards
            // pointing triangle to indicate that it's a parent element. Remove the class from
            // other elements.
            const activeMenuItemLink = activeMenuItem.find( 'a' );
            $( '.menu-depth-1__item__link' ).not( activeMenuItemLink ).removeClass( 'js-current-lvl1-marker' );
            activeMenuItemLink.toggleClass( 'js-current-lvl1-marker' );

            // On opening the submenu, clear the js generated wrapper for bound items to
            // regenerate it according to current menu items bound items
            $( '.nav--desktop__bound-menu-items' ).remove();

            // If lvl 2 submenu, close all other lvl 2 submenus before opening this one
            const menuLevel2NotCurrent = $( '.menu-depth-2' ).not( submenuToOpen );
            menuLevel2NotCurrent.parents( '.submenu-wrap-2' ).addClass( 'submenu-wrap-2--hidden' );
            menuLevel2NotCurrent.addClass( 'submenu--hidden' );

            // Get the parent wrapper to control its visivbility
            const submenuToOpenParentWrap = $( submenuToOpen ).parents( '.submenu-wrap-2' );

            // Get the menu items we want to bind to the right edge of the opened nav
            const boundMenuItems   = submenuToOpenParentWrap.find( '.bind' );

            // This is where we are about to store the menu items in
            let boundMenuItemsHTML = '';

            // Go through each bound menu item to make them a html string,
            // a html <li> item
            boundMenuItems.each( ( e, currentBoundItem ) => {

                // Check if the current menu item is checked to be a sign language button.
                // If it has the class signlanguage, build it with an icon
                if ( $( currentBoundItem ).hasClass( 'signlanguage' ) ) {

                    // Prepend the icon to the signlanguage button. Clear it first to avoid
                    // many icons - each time there is a new append to the same button
                    // which without clearing causes problems
                    const signIcon = '<i class="fal fa-sign-language" aria-hidden="true"></i>';
                    $( currentBoundItem ).find( 'a' ).children( '.fal' ).remove();
                    $( currentBoundItem ).find( 'a' ).prepend( signIcon );

                    // Build the string with the signlanguage icon
                    boundMenuItemsHTML = boundMenuItemsHTML +
                    '<li class="nav--desktop__bound-menu-items__menu-button signlanguage-button">' + $( currentBoundItem ).html() + '</li>';

                }  else {

                    // Build the buttons string without the signlanguage icon
                    boundMenuItemsHTML = boundMenuItemsHTML +
                    '<li class="nav--desktop__bound-menu-items__menu-button">' +
                    $( currentBoundItem ).html() + '</li>';
                }

            });

            // Clear the bound menu items from the normal nav flow
            boundMenuItems.addClass( 'bind--js-hidden' );

            // If there are any bound items, populate them to the right edge of the opened nav
            if ( boundMenuItems.length ) {

                // Build the whole wrapper + contents to the bound menu items section
                const boundMenuItemsString = '<div class="submenu nav--desktop__bound-menu-items"><ul>' + boundMenuItemsHTML + '</ul></div>';

                // Append the bound menu items wrapper to the main wrapper
                $( '.content-wrap-wide-2' ).append( boundMenuItemsString );
            }

            // Get the main wrapper and toggle it on and off if not lvl 3 submenu.
            // Also toggle it contents.
            submenuToOpenParentWrap.toggleClass( 'submenu-wrap-2--hidden' );
            $( submenuToOpen ).toggleClass( 'submenu--hidden' );
        }

     }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
        this.hideSubmenus();
        this.addSignlanguageIcon();
    }
}

// Export the class reference.
module.exports = Menu;



// WEBPACK FOOTER //
// ../vaasa/assets/scripts/menu.js